import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { orderExcursionsStore } from 'entities/excursions/models/order-excursions/order-excursions-store'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { priceShow } from 'shared/lib/priceShow'
import { ButtonInput } from 'shared/ui/button-input'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

type Props = {
  count: number
  price: string | undefined
  currentExcursion: IExcursionDetails
}

export const ParticipantsCounter = ({
  currentExcursion,
  count,
  price,
}: Props) => {
  const { t } = useTranslation()

  const onChangeQuantity = (value: number) => {
    orderExcursionsStore.onPeopleQuantityChange(value)
  }

  useEffect(() => {
    orderExcursionsStore.onTotalPriceChange(Number(price) * count)
  }, [count])
  return (
    <Paper>
      <div className={s.participants}>
        <h4 className={s.participantsTitle}>{t('excursions.participants')}</h4>

        <div className={s.bottom}>
          <p className={s.participantsPrice}>{priceShow(price)} &#8384;</p>
          <ButtonInput
            minNumber={1}
            maxNumber={currentExcursion.seats_remain}
            value={count}
            onChange={onChangeQuantity}
          />
        </div>

        {count === currentExcursion.seats_remain && (
          <p className={s.alert}>{t('excursions.max_count')}</p>
        )}
      </div>
    </Paper>
  )
}
